/** App's URL base path. Matches vite.config.ts `base` and BrowserRouter `basename`. */
export const APP_BASE_PATH = '/app';

/** App display name (used in document.title, PWA prompts, headers). */
export const APP_NAME = 'Harmny';
